// SPA statique pure : pas de rendu serveur, pas de runtime Node en prod — le
// backend FastAPI sert uniquement les fichiers statiques du build. Voir
// vite.config.ts (adapter-static + fallback: 'index.html').
export const ssr = false;
